import { usePageTitle } from "../hooks/TitleHook"

import LayoutWrapper from "../layoutBuilder/LayoutWrapper"
import LayoutItem from "../layoutBuilder/LayoutItem"
import DashboardKPICards from "./sub-components/DashboardKPICards"
import AllEmissionsByMode from "../components/Charts/Wireups/AllEmissionsByMode"
import { useFilterAtomValue } from "../hooks/FilterHooks"
import { usePartnerAtomValue } from "../hooks/PartnerHooks"
import { useAtomValue } from "jotai"
import { userAtom } from "../atoms/user"

const MainChart = () => {
	return (
		<LayoutItem>
			<AllEmissionsByMode />
		</LayoutItem>
	)
}

const Home = () => {
	usePageTitle("BlueHalo - Dashboard")
	const filterDataValue = useFilterAtomValue()
	const partner = usePartnerAtomValue()
	const user = useAtomValue(userAtom)

	// For admin users, only show charts if partner is selected
	// For non-admin users, always show charts
	const shouldShowCharts = user.isAdmin ? Boolean(partner) : true

	return (
		<LayoutWrapper>
			{shouldShowCharts && (
				<>
					<DashboardKPICards filterDataValue={filterDataValue} />
					<MainChart />
				</>
			)}
		</LayoutWrapper>
	)
}

export default Home
